import { IRootState } from '../reducer'
import { prefix } from './actions'

export const atlasModulePanelTarget = (state: IRootState) => state[prefix].target
export const atlasModulePanelChangeCount = (state: IRootState) => state[prefix].changeCount
